<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    color?: string
    size?: number
  }>(),
  {
    color: 'var(--warning)',
    size: 10,
  },
)
</script>

<template>
  <span
    class="pulse-dot"
    :style="{ width: `${props.size}px`, height: `${props.size}px` }"
  >
    <span class="pulse-dot__ring" :style="{ background: props.color }" />
    <span
      class="pulse-dot__core"
      :style="{ background: props.color, boxShadow: `0 0 8px ${props.color}` }"
    />
  </span>
</template>

<style scoped>
.pulse-dot {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.pulse-dot__ring,
.pulse-dot__core {
  position: absolute;
  inset: 0;
  border-radius: 50%;
}
.pulse-dot__ring {
  animation: idi-pulse 1.8s ease-in-out infinite;
}
</style>
